<script>
	import { isValid } from "../../validation";
	import model from "../../stores/modelStore";
	import { registerPageComplete } from "../../gtm";
	import { projectSettings, referralTypes } from "../../config";
	import registrationTypes from "../../config/registrationTypes";

	import ContactWithDoB from "../../components/ContactWithDoB.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import Claimant from "../../components/Claimant.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	export let disabled = null;
	export let pageName = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let buttons = null;
	let required = true;

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
			} else {
				await registerPageComplete(pageName);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};
</script>

<PageSection>
	<Form {disabled} id="form-personal-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Please provide your Contact details</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<ContactWithDoB
				bind:title={$model.Contact.Title}
				bind:firstName={$model.Contact.FirstName}
				bind:surname={$model.Contact.Surname}
				bind:dateOfBirth={$model.Contact.DateOfBirth}
				bind:email={$model.Contact.Email}
				bind:phone={$model.Contact.Phone}
				bind:address={$model.Contact.Address}
				idPrefix="contact"
				{required}
				{disabled}></ContactWithDoB>
		</div>

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<label for="whereDidYouHear" class:isrequired={required}
						>Where did you hear about this class action?</label>
					<Select
						{required}
						{disabled}
						id="whereDidYouHear"
						bind:value={$model.WhereDidYouHear}
						optionList={referralTypes}
						textProperty="name"
						valueProperty="name"></Select>
				</FormColumn>
			</FormRow>
		</div>

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<label for="regType" class:isrequired={required}>Registration Type</label>
					<Select
						{required}
						{disabled}
						id="regType"
						bind:value={$model.RegistrationType}
						optionList={registrationTypes.options}
						textProperty="name"
						valueProperty="value"></Select>
				</FormColumn>
			</FormRow>

			{#if $model.RegistrationType}
				<div class="investor-details">
					<Claimant
						bind:registrationType={$model.RegistrationType}
						bind:investor={$model.InvestorDetails}
						bind:claimant={$model.Claimant}
						bind:jointHoldings={$model.JointHoldings}
						contact={$model.Contact}
						{disabled}
						{required}></Claimant>
				</div>
			{/if}
		</div>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons nextPageLabel="Next" />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	.investor-details {
		margin-bottom: 20px;
	}
</style>
